module.exports = __webpack_public_path__ + "static/media/banner-opx-mob.c3e90584.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-opx-mob.svg
// module id = 2087
// module chunks = 7